export default {
  API_BASE_URL: 'https://mercury-backend.mvfglobal.com',
  AUTH0_DOMAIN: 'auth.mvfglobal.com',
  AUTH0_AUDIENCE: 'https://mercury.mvfglobal.com',
  AUTH0_CLIENT_ID: 'qSvHfMOUVP8JfcnjNq10tIKLiA1k4NbA',
  LOG_ROCKET_ENABLED: false,
};
